// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ThWO","newExpiryDate":"styles_newExpiryDate__1lwse","footer":"styles_footer__2RG6F"};